const $lynkco = $('.lynkco');

if ($lynkco.length > 0) {
    setRotation();
    $(window).on('resize', setRotation);
}

function setRotation() {
    // setting rotation based on viewport width

    let vpWidth = viewport().width,
        factor = 0.04 * vpWidth + 44,
        rotation = (vpWidth / factor) * 360;

    // low screen width = 400px / f60 (0,15%)
    // high screen width = 1400px / f100 (0,07%)
    // formula: y = 0.04 * x + 44

    $lynkco.css({
        '--lynkco-wheel-rotation': '-' + Math.round(rotation) + 'deg'
    });
}
